import './init.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import Env from 'lib/env/Env';
import { initFaro } from 'lib/monitoring/faro';
import App from 'base/App/App';
import { AppErrorBoundary } from 'v5/features/core/app-crash/AppErrorBoundary';
import { ServerUnreachableGate } from 'v5/features/core/server-unreachable/ServerUnreachableGate';
import store from 'store';
import Routes from 'base/Routes/Routes';
import 'styles/index.scss';
import './v4/core/v4-style.css';
import { SocketQueryUpdater } from '~/v4/core/useSocketQueryUpdater';
import { queryClient } from '~/v4/migration/queryClientSingleton';
import { initMigrationCacheReconciler } from '~/v4/migration/cacheReconciler';
import './v5/i18n';
import {
  InternalLocaleProvider,
  MomentLocaleGlobalConfigurator
} from 'v5/i18n';
import { TanstackDevtools } from 'v5/platform/react/TanstackDevtools';
import { NavigationServiceInjector } from 'v5/services/internal/NavigationService/NavigationService.connected.js';
import { GlobalAppScopeProvider } from 'v5/core/app-scope/_private/GlobalAppScopeProvider';
import { RouteChangeEmitter } from 'v5/core/routing/RouteChangeEmitter';
import {
  registerLastNonSettingsPathStorage,
  routeChangeEvent
} from 'v5/core/routing/routeChangeEvent';
import { myPersistentBrowserHistory } from 'v5/platform/navigation/PersistentBrowserHistory.connected';

const history = myPersistentBrowserHistory;

registerLastNonSettingsPathStorage();

initFaro('satie', [Env.apiURL, Env.apiV2URL]);

window.sessionId =
  Date.now().toString(36) + Math.random().toString(36).substring(2);

ReactDOM.createRoot(document.getElementById('root')).render(
  <InternalLocaleProvider>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Router history={history}>
          <AppErrorBoundary>
            <GlobalAppScopeProvider>
              <MomentLocaleGlobalConfigurator />
              <RouteChangeEmitter routeChangeEvent={routeChangeEvent} />
              <NavigationServiceInjector />
              <ServerUnreachableGate>
                <App>
                  <SocketQueryUpdater sessionId={window.sessionId} />
                  <Routes store={store} />
                </App>
              </ServerUnreachableGate>
            </GlobalAppScopeProvider>
          </AppErrorBoundary>
        </Router>
      </Provider>
      <TanstackDevtools />
    </QueryClientProvider>
  </InternalLocaleProvider>
);

initMigrationCacheReconciler(); // for taking some data from other query cache to another query cache. todo remove once we have proper backend api
